import React from 'react'
import Grid from '@material-ui/core/Grid'
import {
  InlineAddress,
  BorderlessParagraphWithBlockSpans,
  StyledExternalLink
} from '../../../../../theme/Global'
import { LocationAddressContainer } from './styles'
import { LocationContentHeading } from '../LocationContent/styles'
import { NS_NULL_VALUE } from '../../../../../app/constants'

export const LocationAddressContent = ({
  address1,
  address2,
  address3,
  shipAttention,
  state,
  zip,
  city
}) => {
  const showFieldRow = (field) => (field && field !== NS_NULL_VALUE ? <span>{field}</span> : null)
  const showField = (field) => (field && field !== NS_NULL_VALUE ? field : null)
  return (
    <InlineAddress>
      {showFieldRow(address1)}
      {showFieldRow(address2)}
      {showFieldRow(address3)}
      <span>
        {`${showField(city)} ${showField(state)} ${showField(zip)}`}
      </span>
      {showField(shipAttention ? `Attn: ${shipAttention}` : null, true)}
    </InlineAddress>
  )
}

const LocationAddress = ({ location }) => (

  <LocationAddressContainer container data-testid="location-address-container">
    <Grid item xs={6}>
      <LocationContentHeading>Location Address:</LocationContentHeading>
    </Grid>
    <Grid item xs={6}>
      <BorderlessParagraphWithBlockSpans data-testid="location-address-paragraph">
        <LocationAddressContent {...location} />
      </BorderlessParagraphWithBlockSpans>
    </Grid>
  </LocationAddressContainer>
)

export default React.memo(LocationAddress)
